import { render } from "./IconSummit.vue?vue&type=template&id=28e5eda8"
import script from "./IconSummit.vue?vue&type=script&lang=js"
export * from "./IconSummit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__